import styled from '@emotion/styled';
import { FormControlLabel } from '@mui/material';

export const StyledLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 12px;
  }
`;
